module.exports = __webpack_public_path__ + "img/glm_gbt6179_1986.prt.2cb86f0f.jpg";